module.exports = __webpack_public_path__ + "static/media/m_eyeshape_almond_lightbrown.51f80631.png";